import apiFetch from '@/utils/apiFetch';

export const feedbackColumns = [
  ['Submitted', 'Submitted'], ['UnderReview', 'Under Review'], ['InProgress', 'In Progress'],
  ['AwaitingApproval', 'Awaiting Approval'], ['AwaitingStaging', 'Awaiting Staging'], ['OnStaging', 'On Staging']
] as const;

export type FeedbackCard = {
  id: string; type: 'Bug' | 'Feature'; title: string; description: string;
  tenantName?: string | null;
  status: string; reporterName: string; createdAt: string; updatedAt: string; completedAt?: string | null; stagedAt?: string | null;
  githubIssueUrl?: string; githubIssueNumber?: number; githubIssueState?: 'open' | 'closed'; factorySyncedAt?: string; syncError?: string;
  syncPending?: boolean; pendingState?: string; canManage?: boolean; canReopen?: boolean;
  cancellationReviewStatus?: 'pending' | 'approved' | 'rejected' | null;
  isWorking?: boolean; latestActivity?: string | null; upvoteCount: number; hasUpvoted: boolean;
  downvoteCount: number; score: number; userVote: -1 | 0 | 1;
};
export type FeedbackAccess = { isInternal: boolean; tenantName: string };
export type FeedbackDetail = FeedbackCard & {
  comments: { id: string; authorName: string; text: string; createdAt: string; source?: string | null; syncPending?: boolean }[];
  activity: { id: string; status: string; message: string; createdAt: string }[];
  screenshots: { id: string; fileName: string; url: string }[];
};
export type ScreenshotUpload = { fileName: string; contentType: string; dataBase64: string };
export async function feedbackRequest<T>(path = '', method = 'GET', data?: unknown, signal?: AbortSignal): Promise<T> {
  const response = await apiFetch(`/community-feedback${path}`, {
    method, signal, ...(data === undefined ? {} : { body: JSON.stringify(data) })
  });
  if (response.status === 204) return undefined as T;
  const text = await response.text();
  return text ? JSON.parse(text) as T : undefined as T;
}

export const feedbackDisplayStatus = (status: string) =>
  ['NeedsAttention', 'Blocked', 'needs_attention', 'blocked'].includes(status) ? 'UnderReview' : status;

export function feedbackVisible(card: FeedbackCard, now = Date.now()): boolean {
  if (card.status === 'Closed' || card.status === 'Completed') return false;
  if (card.status !== 'OnStaging') return true;
  // Status history supplies this timestamp; later edits must not extend the window.
  const staged = Date.parse(card.stagedAt ?? card.createdAt);
  return !Number.isFinite(staged) || now - staged < 7 * 24 * 60 * 60 * 1000;
}
